import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router";

const UpgradePlanModal = ({ userData }) => {
  const [showModal, setShowModal] = useState(false);
  const [intervalId, setIntervalId] = useState(null);

  const navigate = useNavigate();

  const creditPoint = userData?.company_info?.credit_point;
  const userType = userData?.user_info?.user_type;

  useEffect(() => {
    const now = Date.now();
    const fiveSeconds = 5 * 1000;
    const fifteenMinutes = 15 * 60 * 1000;
    let loginTime = localStorage.getItem("loginTime");
    // console.log("loginTime",loginTime)

    let timeoutId;
    let intervalId;

    const checkAndShowModal = () => {
      if (creditPoint === 0) {
        setShowModal(true);
      }
    };

    // First time: no loginTime in storage
    if (!loginTime) {
      loginTime = now.toString();
      timeoutId = setTimeout(() => {
        checkAndShowModal();
        localStorage.setItem("loginTime", loginTime);
      }, fiveSeconds);



    } else {
      const loginTimestamp = parseInt(loginTime, 10);
      const timeSinceLogin = now - loginTimestamp;
      const delayUntilNextCheck = fifteenMinutes - (timeSinceLogin % fifteenMinutes);
      // Set interval to recheck every 5 minutes
      const id = setInterval(() => {
        // shouldShowModal();
      }, 15 * 60 * 1000); // 5 minutes

      // Don't show modal immediately (on hard refresh)
      setShowModal(false);

      // Show first after next 15-minute cycle from login
      timeoutId = setTimeout(() => {
        checkAndShowModal();

        // Then show every 15 minutes
        intervalId = setInterval(() => {
          checkAndShowModal();
        }, fifteenMinutes);
      }, delayUntilNextCheck);
    }

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [creditPoint, userType]);

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white rounded-xl p-6 max-w-lg w-full shadow-2xl relative border-l-8 border-violet-600 mx-4 md:mx-0">
        <button
          onClick={() => setShowModal(false)}
          className="absolute top-4 right-4 text-gray-400 hover:text-violet-600 transition-colors duration-200"
        >
          <FaTimes className="w-5 h-5" />
        </button>
        <div className="mt-4">
          <h2 className="md:text-2xl font-bold text-gray-800 mb-3 text-center">
            Upgrade Plan
          </h2>
          <p className="text-gray-600 mb-6 mt-4 text-center">
            Your current plan has no remaining credits. Please upgrade to continue.
          </p>
          <div className="flex justify-center space-x-3">
            <button
              onClick={() => {
                navigate("/pricing");
                setShowModal(false);
              }}
              className="px-5 py-2.5 bg-gradient-to-br from-violet-500 to-violet-700 text-white rounded-lg transition-colors duration-200 font-medium shadow-sm hover:shadow-violet-200"
            >
              Upgrade Plans
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradePlanModal;
